(() => {
    const COUNTRY_OPTIONS = [
        { value: '10', label: 'Afghanistan' },
        { value: '27', label: 'Aland lslands' },
        { value: '8', label: 'Albania' },
        { value: '9', label: 'Algeria' },
        { value: '141', label: 'American Samoa' },
        { value: '21', label: 'Andorra' },
        { value: '22', label: 'Angola' },
        { value: '23', label: 'Anguilla' },
        { value: '24', label: 'Antigua and Barbuda' },
        { value: '11', label: 'Argentina' },
        { value: '229', label: 'Armenia' },
        { value: '13', label: 'Aruba' },
        { value: '16', label: 'Ascension Island' },
        { value: '25', label: 'Australia' },
        { value: '26', label: 'Austria' },
        { value: '15', label: 'Azerbaijan' },
        { value: '30', label: 'Bahamas' },
        { value: '34', label: 'Bahrain' },
        { value: '145', label: 'Bangladesh' },
        { value: '28', label: 'Barbados' },
        { value: '42', label: 'Belgium' },
        { value: '49', label: 'Belize' },
        { value: '41', label: 'Benin' },
        { value: '38', label: 'Bermuda' },
        { value: '50', label: 'Bhutan' },
        { value: '46', label: 'Bolivia' },
        { value: '47', label: 'Bosnia and Herzegovina' },
        { value: '48', label: 'Botswana' },
        { value: '53', label: 'Bouvet Island' },
        { value: '36', label: 'Brazil' },
        { value: '238', label: 'British Indian Ocean Territory' },
        { value: '216', label: 'Brunei' },
        { value: '39', label: 'Bulgaria' },
        { value: '51', label: 'Burkina Faso' },
        { value: '52', label: 'Burundi' },
        { value: '102', label: 'Cambodia' },
        { value: '105', label: 'Cameroon' },
        { value: '99', label: 'Canada' },
        { value: '73', label: 'Cape Verde' },
        { value: '107', label: 'Cayman Islands' },
        { value: '246', label: 'Central African Republic' },
        { value: '243', label: 'Chad' },
        { value: '245', label: 'Chile' },
        { value: '181', label: 'Christmas Island' },
        { value: '108', label: 'Cocos(Keeling)Islands' },
        { value: '78', label: 'Colombia' },
        { value: '109', label: 'Comoros' },
        { value: '76', label: 'Congo' },
        { value: '77', label: 'Congo(DRC)' },
        { value: '114', label: 'Cook Islands' },
        { value: '79', label: 'Costa Rica' },
        { value: '110', label: "Cote d'Ivoire" },
        { value: '112', label: 'Croatia' },
        { value: '83', label: 'Cuba' },
        { value: '178', label: 'Cyprus' },
        { value: '103', label: 'Czech Republic' },
        { value: '55', label: 'Denmark' },
        { value: '95', label: 'Djibouti' },
        { value: '59', label: 'Dominica' },
        { value: '60', label: 'Dominican Republic' },
        { value: '62', label: 'Ecuador' },
        { value: '17', label: 'Egypt' },
        { value: '173', label: 'El Salvador' },
        { value: '63', label: 'Eritrea' },
        { value: '20', label: 'Estonia' },
        { value: '18', label: 'Ethiopia' },
        { value: '74', label: 'Falkland Islands' },
        { value: '65', label: 'Faroe Islands' },
        { value: '71', label: 'Fiji Islands' },
        { value: '72', label: 'Finland' },
        { value: '64', label: 'France' },
        { value: '66', label: 'Frech Polynesia' },
        { value: '67', label: 'French Guiana' },
        { value: '68', label: 'French Southern and Antarctic Lands' },
        { value: '101', label: 'Gabon' },
        { value: '75', label: 'Gambia' },
        { value: '169', label: 'Georgia' },
        { value: '56', label: 'Germany' },
        { value: '100', label: 'Ghana' },
        { value: '244', label: 'Gibraltar' },
        { value: '222', label: 'Greece' },
        { value: '82', label: 'Greenland' },
        { value: '81', label: 'Grenada' },
        { value: '84', label: 'Guadeloupe' },
        { value: '85', label: 'Guam' },
        { value: '212', label: 'Guatemala' },
        { value: '80', label: 'Guernsey' },
        { value: '97', label: 'Guinea' },
        { value: '98', label: 'Guinea-Bissau' },
        { value: '86', label: 'Guyana' },
        { value: '88', label: 'Haiti' },
        { value: '92', label: 'Heard Island and McDonald Islands' },
        { value: '93', label: 'Honduras' },
        { value: '279', label: 'Hongkong, China' },
        { value: '226', label: 'Hungary' },
        { value: '43', label: 'Iceland' },
        { value: '235', label: 'India' },
        { value: '236', label: 'Indonesia' },
        { value: '232', label: 'Iran' },
        { value: '231', label: 'Iraq' },
        { value: '19', label: 'Ireland' },
        { value: '137', label: 'Isle of Man' },
        { value: '233', label: 'Israel' },
        { value: '234', label: 'Italy' },
        { value: '228', label: 'Jamaica' },
        { value: '170', label: 'Japan' },
        { value: '242', label: 'Jersey' },
        { value: '239', label: 'Jordan' },
        { value: '87', label: 'Kazakhstan' },
        { value: '113', label: 'Kenya' },
        { value: '94', label: 'Kiribati' },
        { value: '89', label: 'Korea' },
        { value: '111', label: 'Kuwait' },
        { value: '96', label: 'Kyrgyzstan' },
        { value: '117', label: 'Laos' },
        { value: '115', label: 'Latvia' },
        { value: '118', label: 'Lebanon' },
        { value: '116', label: 'Lesotho' },
        { value: '119', label: 'Liberia' },
        { value: '120', label: 'Libya' },
        { value: '122', label: 'Liechtenstein' },
        { value: '121', label: 'Lithuania' },
        { value: '124', label: 'Luxembourg' },
        { value: '280', label: 'Macao, China' },
        { value: '133', label: 'Macedonia,Former Yugoslav Republic of' },
        { value: '127', label: 'Madagascar' },
        { value: '130', label: 'Malawi' },
        { value: '131', label: 'Malaysia' },
        { value: '128', label: 'Maldives' },
        { value: '132', label: 'Mali' },
        { value: '129', label: 'Malta' },
        { value: '134', label: 'Marshall Islands' },
        { value: '135', label: 'Martinique' },
        { value: '139', label: 'Mauritania' },
        { value: '138', label: 'Mauritius' },
        { value: '136', label: 'Mayotte' },
        { value: '153', label: 'Mexico' },
        { value: '146', label: 'Micronesia' },
        { value: '149', label: 'Moldova' },
        { value: '151', label: 'Monaco' },
        { value: '143', label: 'Mongolia' },
        { value: '144', label: 'Montserrat' },
        { value: '150', label: 'Morocco' },
        { value: '152', label: 'Mozambique' },
        { value: '148', label: 'Myanmar' },
        { value: '154', label: 'Namibia' },
        { value: '158', label: 'Nauru' },
        { value: '159', label: 'Nepal' },
        { value: '90', label: 'Netherlands' },
        { value: '91', label: 'Netherlands Antilles' },
        { value: '224', label: 'New Caledonia' },
        { value: '225', label: 'New Zealand' },
        { value: '160', label: 'Nicaragua' },
        { value: '161', label: 'Niger' },
        { value: '162', label: 'Nigeria' },
        { value: '163', label: 'Niue' },
        { value: '165', label: 'Norfolk Island' },
        { value: '40', label: 'Northern Mariana Islands' },
        { value: '54', label: 'North Korea' },
        { value: '164', label: 'Norway' },
        { value: '14', label: 'Oman' },
        { value: '31', label: 'Pakistan' },
        { value: '166', label: 'Palau' },
        { value: '33', label: 'Palestinian Authority' },
        { value: '35', label: 'Panama' },
        { value: '29', label: 'Papua New Guinea' },
        { value: '32', label: 'Paraguay' },
        { value: '147', label: 'Peru' },
        { value: '70', label: 'Philippines' },
        { value: '167', label: 'Pitcairn Islands' },
        { value: '45', label: 'Poland' },
        { value: '168', label: 'Portugal' },
        { value: '44', label: 'Puerto Rico' },
        { value: '106', label: 'Qatar' },
        { value: '123', label: 'Reunion' },
        { value: '126', label: 'Romania' },
        { value: '61', label: 'Russia' },
        { value: '125', label: 'Rwanda' },
        { value: '174', label: 'Samoa' },
        { value: '186', label: 'San Marino' },
        { value: '182', label: 'Sao Tome and Principe' },
        { value: '180', label: 'Saudi Arabia' },
        { value: '177', label: 'Senegal' },
        { value: '175', label: 'Serbia,Montenegro' },
        { value: '179', label: 'Seychelles' },
        { value: '176', label: 'Sierra Leone' },
        { value: '223', label: 'Singapore' },
        { value: '190', label: 'Slovakia' },
        { value: '191', label: 'Slovenia' },
        { value: '196', label: 'Solomon Islands' },
        { value: '197', label: 'Somalia' },
        { value: '155', label: 'South Africa' },
        { value: '157', label: 'South Georgia and South Sandwich Islands' },
        { value: '221', label: 'Spain' },
        { value: '189', label: 'Sri Lanka' },
        { value: '183', label: 'St.Helena' },
        { value: '184', label: 'St.Kitts and Nevis' },
        { value: '185', label: 'St.Lucia' },
        { value: '187', label: 'St.Pierre and Miquelon' },
        { value: '188', label: 'St.Vincent and the Grenadines' },
        { value: '194', label: 'Sudan' },
        { value: '195', label: 'Suriname' },
        { value: '192', label: 'Svalbard and Jan Mayen' },
        { value: '193', label: 'Swaziland' },
        { value: '171', label: 'Sweden' },
        { value: '172', label: 'Switzerland' },
        { value: '227', label: 'Syria' },
        { value: '278', label: 'Taiwan, China' },
        { value: '198', label: 'Tajikistan' },
        { value: '200', label: 'Tanzania' },
        { value: '199', label: 'Thailand' },
        { value: '57', label: 'Timor-Leste' },
        { value: '58', label: 'Togo' },
        { value: '209', label: 'Tokelau' },
        { value: '201', label: 'Tonga' },
        { value: '204', label: 'Trinidad and Tobago' },
        { value: '203', label: 'Tristan da Cunha' },
        { value: '205', label: 'Tunisia' },
        { value: '207', label: 'Turkey' },
        { value: '208', label: 'Turkmenistan' },
        { value: '202', label: 'Turks and Caicos Islands' },
        { value: '206', label: 'Tuvalu' },
        { value: '217', label: 'Uganda' },
        { value: '218', label: 'Ukraine' },
        { value: '12', label: 'United Arab Emirates' },
        { value: '237', label: 'United Kingdom' },
        { value: '140', label: 'United States' },
        { value: '142', label: 'United States Minor Outlying Islands' },
        { value: '219', label: 'Uruguay' },
        { value: '220', label: 'Uzbekistan' },
        { value: '211', label: 'Vanuatu' },
        { value: '69', label: 'Vatican City' },
        { value: '215', label: 'Venezuela' },
        { value: '240', label: 'Vietnam' },
        { value: '213', label: 'Virgin Islands' },
        { value: '214', label: 'Virgin Islands,British' },
        { value: '210', label: 'Wallis and Futuna' },
        { value: '37', label: 'White Russia' },
        { value: '230', label: 'Yemen' },
        { value: '241', label: 'Zambia' },
        { value: '104', label: 'Zimbabwe' }
    ];

    function setFeedback(section, type, message) {
        const errorEl = section.querySelector('[data-feedback-error]');
        const successEl = section.querySelector('[data-feedback-success]');

        if (errorEl) {
            errorEl.hidden = true;
            errorEl.textContent = '';
        }

        if (successEl) {
            successEl.hidden = true;
            successEl.textContent = '';
        }

        if (!message) return;

        if (type === 'error' && errorEl) {
            errorEl.textContent = message;
            errorEl.hidden = false;
        }

        if (type === 'success' && successEl) {
            successEl.textContent = message;
            successEl.hidden = false;
        }
    }

    function validateField(field, messages) {
        const value = field.value.trim();

        if (field.dataset.required === 'true' && !value) {
            return messages.required;
        }

        if (field.dataset.type === 'email' && value) {
            const emailReg = /^[a-z0-9]+([._\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+\.){1,63}[a-z0-9]+$/i;
            if (!emailReg.test(value)) {
                return messages.email;
            }
        }

        if (field.dataset.type === 'phone' && value) {
            const numeric = value.replace(/\D/g, '');
            if (numeric.length < 5) {
                return messages.phone;
            }
        }

        return '';
    }

    function renderCountries(select) {
        if (!select || select.dataset.countriesRendered === 'true') {
            return;
        }

        const placeholderText = select.options[0] ? select.options[0].textContent : 'Country*';
        select.innerHTML = '';

        const placeholderOption = document.createElement('option');
        placeholderOption.value = '';
        placeholderOption.textContent = placeholderText;
        placeholderOption.selected = true;
        select.appendChild(placeholderOption);

        COUNTRY_OPTIONS.forEach((item) => {
            const option = document.createElement('option');
            option.value = item.value;
            option.textContent = item.label;
            select.appendChild(option);
        });

        select.dataset.countriesRendered = 'true';
    }

    function updateFieldFilledState(field) {
        if (!field || !field.classList || !field.classList.contains('contact-us-2026__field')) {
            return;
        }

        const isFilled = String(field.value || '').trim() !== '';
        field.classList.toggle('is-filled', isFilled);
    }

    function bindFieldStates(form) {
        if (!form || form.dataset.contactUsFieldStateInit === 'true') {
            return;
        }

        const fields = form.querySelectorAll('.contact-us-2026__field');
        fields.forEach((field) => {
            updateFieldFilledState(field);

            const syncState = () => {
                updateFieldFilledState(field);
            };

            field.addEventListener('input', syncState);
            field.addEventListener('change', syncState);
            field.addEventListener('blur', syncState);
        });

        form.dataset.contactUsFieldStateInit = 'true';
    }

    function md5(str) {
        // Ensure md5 input matches backend UTF-8 byte hashing for non-ASCII characters.
        str = unescape(encodeURIComponent(str));

        function cmn(q, a, b, x, s, t) {
            a = (a + q + x + t) | 0;
            return (((a << s) | (a >>> (32 - s))) + b) | 0;
        }

        function ff(a, b, c, d, x, s, t) {
            return cmn((b & c) | ((~b) & d), a, b, x, s, t);
        }

        function gg(a, b, c, d, x, s, t) {
            return cmn((b & d) | (c & (~d)), a, b, x, s, t);
        }

        function hh(a, b, c, d, x, s, t) {
            return cmn(b ^ c ^ d, a, b, x, s, t);
        }

        function ii(a, b, c, d, x, s, t) {
            return cmn(c ^ (b | (~d)), a, b, x, s, t);
        }

        function md5Cycle(x, k) {
            let a = x[0];
            let b = x[1];
            let c = x[2];
            let d = x[3];

            a = ff(a, b, c, d, k[0], 7, -680876936);
            d = ff(d, a, b, c, k[1], 12, -389564586);
            c = ff(c, d, a, b, k[2], 17, 606105819);
            b = ff(b, c, d, a, k[3], 22, -1044525330);
            a = ff(a, b, c, d, k[4], 7, -176418897);
            d = ff(d, a, b, c, k[5], 12, 1200080426);
            c = ff(c, d, a, b, k[6], 17, -1473231341);
            b = ff(b, c, d, a, k[7], 22, -45705983);
            a = ff(a, b, c, d, k[8], 7, 1770035416);
            d = ff(d, a, b, c, k[9], 12, -1958414417);
            c = ff(c, d, a, b, k[10], 17, -42063);
            b = ff(b, c, d, a, k[11], 22, -1990404162);
            a = ff(a, b, c, d, k[12], 7, 1804603682);
            d = ff(d, a, b, c, k[13], 12, -40341101);
            c = ff(c, d, a, b, k[14], 17, -1502002290);
            b = ff(b, c, d, a, k[15], 22, 1236535329);

            a = gg(a, b, c, d, k[1], 5, -165796510);
            d = gg(d, a, b, c, k[6], 9, -1069501632);
            c = gg(c, d, a, b, k[11], 14, 643717713);
            b = gg(b, c, d, a, k[0], 20, -373897302);
            a = gg(a, b, c, d, k[5], 5, -701558691);
            d = gg(d, a, b, c, k[10], 9, 38016083);
            c = gg(c, d, a, b, k[15], 14, -660478335);
            b = gg(b, c, d, a, k[4], 20, -405537848);
            a = gg(a, b, c, d, k[9], 5, 568446438);
            d = gg(d, a, b, c, k[14], 9, -1019803690);
            c = gg(c, d, a, b, k[3], 14, -187363961);
            b = gg(b, c, d, a, k[8], 20, 1163531501);
            a = gg(a, b, c, d, k[13], 5, -1444681467);
            d = gg(d, a, b, c, k[2], 9, -51403784);
            c = gg(c, d, a, b, k[7], 14, 1735328473);
            b = gg(b, c, d, a, k[12], 20, -1926607734);

            a = hh(a, b, c, d, k[5], 4, -378558);
            d = hh(d, a, b, c, k[8], 11, -2022574463);
            c = hh(c, d, a, b, k[11], 16, 1839030562);
            b = hh(b, c, d, a, k[14], 23, -35309556);
            a = hh(a, b, c, d, k[1], 4, -1530992060);
            d = hh(d, a, b, c, k[4], 11, 1272893353);
            c = hh(c, d, a, b, k[7], 16, -155497632);
            b = hh(b, c, d, a, k[10], 23, -1094730640);
            a = hh(a, b, c, d, k[13], 4, 681279174);
            d = hh(d, a, b, c, k[0], 11, -358537222);
            c = hh(c, d, a, b, k[3], 16, -722521979);
            b = hh(b, c, d, a, k[6], 23, 76029189);
            a = hh(a, b, c, d, k[9], 4, -640364487);
            d = hh(d, a, b, c, k[12], 11, -421815835);
            c = hh(c, d, a, b, k[15], 16, 530742520);
            b = hh(b, c, d, a, k[2], 23, -995338651);

            a = ii(a, b, c, d, k[0], 6, -198630844);
            d = ii(d, a, b, c, k[7], 10, 1126891415);
            c = ii(c, d, a, b, k[14], 15, -1416354905);
            b = ii(b, c, d, a, k[5], 21, -57434055);
            a = ii(a, b, c, d, k[12], 6, 1700485571);
            d = ii(d, a, b, c, k[3], 10, -1894986606);
            c = ii(c, d, a, b, k[10], 15, -1051523);
            b = ii(b, c, d, a, k[1], 21, -2054922799);
            a = ii(a, b, c, d, k[8], 6, 1873313359);
            d = ii(d, a, b, c, k[15], 10, -30611744);
            c = ii(c, d, a, b, k[6], 15, -1560198380);
            b = ii(b, c, d, a, k[13], 21, 1309151649);
            a = ii(a, b, c, d, k[4], 6, -145523070);
            d = ii(d, a, b, c, k[11], 10, -1120210379);
            c = ii(c, d, a, b, k[2], 15, 718787259);
            b = ii(b, c, d, a, k[9], 21, -343485551);

            x[0] = (x[0] + a) | 0;
            x[1] = (x[1] + b) | 0;
            x[2] = (x[2] + c) | 0;
            x[3] = (x[3] + d) | 0;
        }

        function md5Blk(s) {
            const md5blks = [];
            for (let i = 0; i < 64; i += 4) {
                md5blks[i >> 2] =
                    s.charCodeAt(i) +
                    (s.charCodeAt(i + 1) << 8) +
                    (s.charCodeAt(i + 2) << 16) +
                    (s.charCodeAt(i + 3) << 24);
            }
            return md5blks;
        }

        function md51(s) {
            const n = s.length;
            const state = [1732584193, -271733879, -1732584194, 271733878];
            let i;

            for (i = 64; i <= n; i += 64) {
                md5Cycle(state, md5Blk(s.substring(i - 64, i)));
            }

            s = s.substring(i - 64);
            const tail = new Array(16).fill(0);
            for (i = 0; i < s.length; i += 1) {
                tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
            }
            tail[i >> 2] |= 0x80 << ((i % 4) << 3);

            if (i > 55) {
                md5Cycle(state, tail);
                for (let j = 0; j < 16; j += 1) {
                    tail[j] = 0;
                }
            }

            tail[14] = n * 8;
            md5Cycle(state, tail);
            return state;
        }

        function rhex(n) {
            const hexChr = '0123456789abcdef';
            let s = '';
            for (let j = 0; j < 4; j += 1) {
                s += hexChr.charAt((n >> (j * 8 + 4)) & 0x0f) + hexChr.charAt((n >> (j * 8)) & 0x0f);
            }
            return s;
        }

        return md51(str).map(rhex).join('');
    }

    function buildPayload(form) {
        const formData = new FormData(form);
        const payload = {};

        formData.forEach((value, key) => {
            payload[key] = String(value).trim();
        });

        return payload;
    }

    function buildSign(payload, timestamp, secret) {
        const keys = Object.keys(payload);
        const signParams = new URLSearchParams();

        keys.forEach((key) => {
            signParams.append(key, payload[key]);
        });

        signParams.append('time', timestamp);
        signParams.append('secret', secret);
        const signRaw = signParams.toString();
        return md5(signRaw);
    }

    async function submitForm(section, payload, messages) {
        const submitUrl = (section.dataset.submitUrl || '').trim();
        const submitSecret = (section.dataset.submitSecret || '').trim();

        if (!submitUrl) {
            throw new Error(messages.submitError);
        }

        const timestamp = String(Math.floor(Date.now() / 1000));
        const bodyParams = new URLSearchParams();

        Object.keys(payload).forEach((key) => {
            bodyParams.append(key, payload[key]);
        });
        console.log('Submitting form to:', submitUrl, 'with payload:', bodyParams.toString(), 'and sign:', buildSign(payload, timestamp, submitSecret));
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', submitUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
            xhr.setRequestHeader('X-Sign', buildSign(payload, timestamp, submitSecret));
            xhr.setRequestHeader('X-Timestamp', timestamp);
            xhr.onreadystatechange = () => {
                if (xhr.readyState !== 4) {
                    return;
                }
                
                const isSuccess = xhr.status >= 200 && xhr.status < 300;
                if (isSuccess) {
                    resolve(xhr);
                    return;
                }

                let serverMessage = '';
                try {
                    const responseData = JSON.parse(xhr.responseText || '{}');
                    if (responseData && typeof responseData.message === 'string') {
                        serverMessage = responseData.message;
                    }
                } catch (e) {
                    serverMessage = '';
                }

                reject(new Error(serverMessage || messages.submitError));
            };

            xhr.onerror = () => {
                reject(new Error(messages.submitError));
            };

            xhr.send(bodyParams.toString());
        });
    }

    function initSectionAnimation(section) {
        if (!section || section.dataset.contactUsAnimInit === 'true') {
            return;
        }

        const animatedItems = section.querySelectorAll('.contact-us-2026__form-row, .contact-us-2026__message-wrap, .contact-us-2026__actions, .contact-us-2026__info-card');
        if (!animatedItems.length) {
            return;
        }

        const reveal = () => {
            // Reset animation state
            animatedItems.forEach((item) => {
                item.classList.remove('is-visible');
            });
            
            // Trigger reflow to restart animation
            void section.offsetHeight;
            
            // Reveal items with staggered timing
            animatedItems.forEach((item, index) => {
                setTimeout(() => {
                    item.classList.add('is-visible');
                }, index * 140);
            });
        };

        section.classList.add('contact-us-2026--anim-ready');
        section.dataset.contactUsAnimInit = 'true';

        if ('IntersectionObserver' in window) {
            const observerTarget = section.querySelector('.contact-us-2026__card') || section;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        reveal();
                    }
                });
            }, { threshold: 0.2 });

            observer.observe(observerTarget);
        } else {
            reveal();
        }
    }

    function initSection(section) {
        if (!section || section.dataset.contactUsInit === 'true') {
            return;
        }

        const form = section.querySelector('.contact-us-2026__form');
        const countrySelect = section.querySelector('[data-country-select]');
        const submitButton = section.querySelector('.contact-us-2026__submit');

        if (!form || !countrySelect) {
            return;
        }

        renderCountries(countrySelect);
        bindFieldStates(form);
        updateFieldFilledState(countrySelect);
        initSectionAnimation(section);

        const messages = {
            required: section.dataset.validationRequired || 'The required fields cannot be blank',
            email: section.dataset.validationEmail || 'Make sure the email format is correct',
            phone: section.dataset.validationPhone || 'Your phone number should be at least 5 digits long',
            success: section.dataset.successMessage || 'Submitted successfully.',
            submitError: section.dataset.submitError || 'Submission failed, please try again later.'
        };

        form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const fields = form.querySelectorAll('[data-required], [data-type]');
            for (let i = 0; i < fields.length; i += 1) {
                const error = validateField(fields[i], messages);
                if (error) {
                    setFeedback(section, 'error', error);
                    fields[i].focus();
                    return;
                }
            }

            const payload = buildPayload(form);

            if (submitButton) {
                submitButton.disabled = true;
                submitButton.classList.add('is-loading');
                submitButton.setAttribute('aria-busy', 'true');
            }
            try {
                const msg = await submitForm(section, payload, messages);
                const responseData = msg && msg.responseText ? JSON.parse(msg.responseText) : null;
                if (responseData && responseData.code == 200) {
                    setFeedback(section, 'success', messages.success);
                    form.reset();
                    countrySelect.value = '';
                    form.querySelectorAll('.contact-us-2026__field').forEach((field) => {
                        updateFieldFilledState(field);
                    });
                } else {
                    setFeedback(section, 'error', (responseData && responseData.message) || messages.submitError);
                }
            } catch (error) {
                setFeedback(section, 'error', error.message || messages.submitError);
            } finally {
                if (submitButton) {
                    submitButton.disabled = false;
                    submitButton.classList.remove('is-loading');
                    submitButton.removeAttribute('aria-busy');
                }
            }
        });

        section.dataset.contactUsInit = 'true';
    }

    function initAllSections() {
        document.querySelectorAll('.contact-us-2026').forEach((section) => {
            initSection(section);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllSections, { once: true });
    } else {
        initAllSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
        if (event.target && event.target.classList && event.target.classList.contains('contact-us-2026')) {
            initSection(event.target);
            return;
        }

        if (event.target && event.target.querySelector) {
            const nestedSection = event.target.querySelector('.contact-us-2026');
            if (nestedSection) {
                initSection(nestedSection);
            }
        }
    });
})();
